import * as MutationTypes from './mutationTypes';
import { MenuBannerRecommendation } from './models';
import * as api from './api';

export const bannerRecommendationListRequest = async ({
  commit,
  getters: { menuBannerRecommendationList }
}, pointOfSaleGuid) => {
  if (menuBannerRecommendationList.length === 0) {
    const response = await api.bannerRecommendationListRequest(pointOfSaleGuid);
    const recommendationList = MenuBannerRecommendation.toInstanceList(response.data);
    commit(MutationTypes.BANNER_RECOMMENDATION_LIST_SUCCESS, recommendationList);
  }
};

export const deleteBannerRecommendation = async ({ commit }, recommendation) => {
  await api.deleteBannerRecommendationRequest(recommendation.guid);
  commit(MutationTypes.DELETE_BANNER_RECOMMENDATION_SUCCESS, recommendation);
  return recommendation;
};

export const createBannerRecommendation = async ({ commit }, recommendation) => {
  const response = await api.createBannerRecommendationRequest(recommendation.getFormData());
  // Check 409
  const newRecommendation = MenuBannerRecommendation.toInstance(response.data);
  commit(MutationTypes.CREATE_BANNER_RECOMMENDATION_SUCCESS, newRecommendation);
  return newRecommendation;
};

export const editBannerRecommendation = async ({ commit }, recommendation) => {
  const response = await api.editBannerRecommendationRequest(recommendation.guid, recommendation.getFormData());
  // Check 409
  const editedRecommendation = MenuBannerRecommendation.toInstance(response.data);
  commit(MutationTypes.EDIT_BANNER_RECOMMENDATION_SUCCESS, editedRecommendation);
  return recommendation;
};
